export const navData = [
  {
    name: "Home",
    href: "home",
  },
  {
    name: "Community",
    href: "community",
  },
  {
    name: "Blog",
    href: "blog",
  },
  {
    name: "Events",
    href: "events",
  },
];
